var map = {
	"./after-match.svg": 3371,
	"./before-match.svg": 2701,
	"./chat-with-friends.svg": 5459,
	"./check-game-stats.svg": 2274,
	"./check-live-scores.svg": 758,
	"./don't-use.svg": 8803,
	"./during-match.svg": 6601,
	"./games-console.svg": 9517,
	"./half-time.svg": 7865,
	"./laptop.svg": 5233,
	"./live-quizzes.svg": 8947,
	"./mobile--tablet.svg": 2623,
	"./online-polls.svg": 5803,
	"./smart-tv.svg": 6273,
	"./social-media.svg": 6683,
	"./vote-on-music.svg": 2162,
	"./vr.svg": 7225,
	"./watch-fan-commentary.svg": 3430,
	"./website--app.svg": 414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2088;